import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail } from "lucide-react";
import { useScrollAnimation, fadeInUp, AnimatedDiv, AnimatedH2 } from "@/hooks/useScrollAnimation";
import gurbirPhoto from "@/assets/gurbir-samran-headshot.png";

const AgentCard = () => {
  const { ref, controls } = useScrollAnimation();

  return (
    <section className="py-20 md:py-28 bg-muted">
      <div className="container mx-auto px-4 md:px-6">
        <AnimatedDiv
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <p className="text-sm font-medium text-primary tracking-[0.3em] uppercase mb-4">Your Expert</p>
          <AnimatedH2 variants={fadeInUp} className="text-3xl md:text-5xl heading-luxury text-foreground mb-4">
            Real Estate Agent
          </AnimatedH2>
          <div className="section-divider mt-4"></div>
        </AnimatedDiv>

        <AnimatedDiv variants={fadeInUp} className="max-w-2xl mx-auto">
          <Card className="bg-card border-0 shadow-xl overflow-hidden">
            <CardContent className="p-10 text-center">
              <div className="w-36 h-36 mx-auto mb-6 rounded-full overflow-hidden border-4 border-primary/20 shadow-lg">
                <img 
                  src={gurbirPhoto} 
                  alt="Gurbir Samran - Farm & Land Real Estate Specialist" 
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width={144}
                  height={144}
                />
              </div>
              
              <h3 className="text-3xl font-bold text-foreground mb-2">Gurbir Samran</h3>
              <p className="text-primary font-semibold text-lg mb-6">Farm & Land Real Estate Specialist</p>
              
              <p className="text-muted-foreground leading-relaxed mb-8 max-w-lg mx-auto">
                Multi-generational farmer and licensed real estate agent with deep expertise in California's Central Valley agricultural market. Specializing in almond and pistachio orchards, farmland acquisitions, and agricultural property management.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:+15598719051" className="flex items-center justify-center gap-2 text-foreground hover:text-primary transition-colors font-medium">
                  <Phone className="h-5 w-5 text-primary" />
                  (559) 871-9051
                </a>
                <a href="mailto:gurbirsamran@gmail.com" className="flex items-center justify-center gap-2 text-foreground hover:text-primary transition-colors font-medium">
                  <Mail className="h-5 w-5 text-primary" />
                  gurbirsamran@gmail.com
                </a>
              </div>
            </CardContent>
          </Card>
        </AnimatedDiv>
      </div>
    </section>
  );
};

export default AgentCard;
